// Display labels for every layer ID in DEFAULT_EXPORT_LAYERS plus a few extras.
export const LAYER_NAMES = {
  'cover-page':                          'Cover Front',
  'helix-report': 'Helix, Spring and Stud',
  'numero-vastu-report': 'Numero Vastu',
  'astro-vastu-report': 'Astro Vastu',
  'cut-zone-report': 'Cut Zones',
  'extension-zone-report': 'Extension Zones',
  'cover-index':                         'Cover Index',
  'cover-back-page':                     'Cover Back',
  'floor-plan':                          'Floor plan',
  'grid-layout':                         'Floor plan with grid',
  'center-analysis':                     'Center analysis',
  'mahavastu-chakra':                    'Mahavastu Chakra',
  'Vedic-Mahavastu-Chakra':              'Vedic Shakti Chakra',
  'shakti-chakra':                       'Shakti Chakra',
  'floor-plan-vpm':                      'Floor plan with VPM',
  'compass-8':                           '8 Zones Analysis',
  'Bar-chart-8':                         '8 Zones Bar Chart',
  'Bar-chart-8-table':                   '8 Zones Table',
  'Bar-chart-8-chart':                   '8 Zones Bar Chart',
  'compass-16':                          '16 Zones Analysis',
  'Bar-chart-16':                        '16 Zones Bar Chart',
  'Bar-chart-16-table':                  '16 Zones Table',
  'Bar-chart-16-chart':                  '16 Zones Bar Chart',
  'compass-24':                          '24 Zones Analysis',
  'compass-32':                          '32 Mahavastu Zones',
  'Bar-chart-32':                        '32 Mahavastu Bar Chart',
  'Bar-chart-32-table':                  '32 Mahavastu Table',
  'Bar-chart-32-chart':                  '32 Mahavastu Bar Chart',
  'compass-45':                          'Vedic 45 Devata (with name)',
  'compass-45-table':                    'Vedic 45 Devata Table',
  'compass-45-chart':                    'Vedic 45 Devata Bar Chart',
  'compass-45-2':                        'Modern 45 Devata (with name)',
  'compass-45-2-table':                  'Modern 45 Devata Table',
  'compass-45-2-chart':                  'Modern 45 Devata Bar Chart',
  'coloured-zone':                       'Coloured Zone',
  'elemental-5-zone':                    'Modern 5 Elemental Zone',
  'elemental-5-chart':                   'Modern 5 Elemental Pie Chart',
  'marmsthan-analysis':                  'Marmsthan (Shanmahanti) Analysis',
  'marmsthan-advance':                   'Advance Marmsthan Analysis',
  'vastu-numbers-81-numbers':            'Modern Vastu Numbers with Devata 81',
  'vastu-numbers-81-numbers-Vedic':      'Vastu Numbers with Devata 81 (Vedic)',
  'vastu-numbers-64':                    'Modern Vastu Numbers 64',
  'grid-3x3':                            '3X3 Grid',
  'entrance-analysis-report':            'Entrance Analysis Report',
  'space-analysis-report':               'Space Analysis Report',
  'png-image-1':                         'Image - 1',
  'png-image-2':                         'Image - 2',
  'Khanija-Dhatu':                       'Khanija Dhatu',
  '16-Directional-Domestic-Vastu':       '16 Directional Domestic Vastu',
  'Direction-Diety-Planet':              'Direction Deity Planet',
  'Devata-Khanij':                       'Devata Khanij',
  'Devata-Bhojan':                       'Devata Bhojan',
  'Devata-Bhojan-aadi':                  'Devata Bhojan Aadi',
  'Devata-chinha':                       'Devata Chinha',
  'Devata-chinha-aadi':                  'Devata Chinha Aadi',
  'Muhurat-vichar':                      'Muhurat Vichar',
  'Seharumkh-achintya-vibhav':           'Seharumkh Achintya Vibhav',
  'Vedic-devata-Numbers-with-Names-81':  'Vedic devata Numbers with Names 81',
  'Disha-Gandha':                        'Disha Gandha',
  'Devata-Nighat':                       'Devata Nighat',
  'Nighantu':                            'Nighantu + artha',
  'Vedic-zones-32':                      '32 Zones Vedic',
  'Vedic-numbers-64':                    '64 Grid',
  'Vedic-64-padvinyash':                 '81 Padvinyash Analysis',
  'Vedic-81-padvinyash':                 '64 Padvinyash Analysis',
  'Vedic-elemental-zone':                'Elemental Zone (Vedic)',
  'Vedic-planet-zoning':                 'Vedic Planet Zoning',
  'surya-chandra-bhag':                  'Surya Chandra Bhag',
  '4-state-image':                       '4 State Analysis',
  'tri-dosh-Vedic':                      'Tri Dosh Vedic Analysis',
  'tri-guna-Vedic':                      'Tri Guna Vedic Analysis',
  'tri-guna-modern':                     'Tri Dosh Modern Analysis',
  'tri-dosh-modern':                     'Tri Guna Modern Analysis',
  'body-part-division':                  'Body Part Division Analysis',
  'tridosha-modern':                     'Tridosha Modern vastu',
  'tridosha-Vedic':                      'Tridosha Vedic Vastu',
  'triguna-modern':                      'Triguna Modern',
  'triguna-Vedic':                       'Triguna Vedic Vastu',
  '64-gridded-image':                    '64 Gridded Image',
  'body-part-mapping':                   'Body-Part Mapping',
  'body-part-mapping-chart':             'Body-Part Mapping Bar chart',
  '4-states-image':                      '4 States Image',
  'MANDAL':                              'Mandal Image',
  'RATNA-STHAPNA':                       'Ratna Sthapna',
  'nakshatra-vastu':                     'Nakshatra Vastu',
  'Devata-Nakshatra-Vastu':              'Devta Nakshatra Vastu',
  '32-Entrance-Analysis-Compass':        '32 Entrance Analysis Compass',

  // Planning Guide
  'house-bank':                          'Bank',
  'house-clinic':                        'Clinic',
  'house-electronic-shop':               'Electronic Shop',
  'house-factory':                       'Factory',
  'house-hotel':                         'Hotel',
  'house-marriage-hall':                 'Marriage Hall',
  'house-multiplex':                     'Multiplex',
  'house-office-cabin':                  'Office Cabin',
  'house-petrol-pump':                   'Petrol Pump',
  'house-retail-outlets':                'Retail Outlets',
  'house-school-college':                'School & College',
  'house-space-analysis-compass':        'Residential Analysis Compass',
  'house-temple':                        'Temple',
};

export const getLayerName = (layerId) => LAYER_NAMES[layerId] || layerId;
